'use es6';

export const getUnusedFiltersData = state => state.storefront.unusedFilters.data;
export const getUnusedFiltersRequestState = state => state.storefront.unusedFilters.requestState;
export const selectResultsView = state => state.storefront.resultsView;